<template>
  <div class="v-tool">
    <h1>
      <!-- <i class="animated bounceIn" :class="icon"/> -->
      <span class="animated fadeInRight" v-text="title"/>
      <span style="float: right;cursor: pointer;margin-right: 5px">
        <el-date-picker
          v-model="monthStr"
          placeholder="选择月"
          type="month"
          value-format="yyyy-MM"
          @input="zdChange">
        </el-date-picker>
      </span>
    </h1>
    <div class="v-tool__box">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    monthStr: {
      type: String,
      default: () => "",
    },
    title: {
      type: String,
      default: () => "",
    },
    ryType: {
      type: String,
      default: () => "",
    },
    icon: {
      type: String,
      default: () => "",
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // teamLeaderTime: moment().format("yyyy-MM"),
      // clanTime: moment().format("yyyy-MM")
    }
  },
  methods: {
    // ryChange(val) {
    //   this.$emit('ryChange', val)
    // },
    zdChange(val) {
      this.$emit('zdChange', val,this.ryType)
    }
  },
  mounted() {

  }
};
</script>

<style lang="scss" scoped>
.v-tool {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 5px #ccc;

  h1 {
    font-size: 15px;
    padding: 10px;
    border-bottom: 1px solid #f5f5f5;
    margin: auto;

    span {
      display: inline-block;
      padding-left: .5rem;
    }
  }

  &__box {
    padding: 1rem;
  }
}
</style>
